export function getNotificationSoundUrl(filename: string): string {
  return `${import.meta.env.BASE_URL}static/sounds/${filename}`
}
